import script from "./TransitionExpand.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransitionExpand.vue?vue&type=script&setup=true&lang=ts"

import "./TransitionExpand.vue?vue&type=style&index=0&id=aa928c16&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa928c16"]])

export default __exports__